import PolicyPage from "../components/policy/PolicyPage";

export default function RulesPage() {
  return (
    <PolicyPage
      documentType="rules"
      subtitle="What's allowed, what isn't, and what happens if a request crosses the line"
    />
  );
}
